import { useEffect, useState } from 'react';
import lcid from 'lcid';

/**
 * Display events and translations in table format
 */
const EventTableBlock = ({ events, translations }) => {
  const [allLcIds, setAllLcIds] = useState([]);

  useEffect(() => {
    if (!translations) return;
    const ids = new Set();
    translations.forEach(t => {
      Object.keys(t.languages).forEach(id => ids.add(Number(id)));
    });
    setAllLcIds(Array.from(ids));
  }, [translations]);

  return (
    <>
      {events && events.length > 0 && (
        <table className="event-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Display Name (TxtId)</th>
              <th>Severity</th>
            </tr>
          </thead>
          <tbody>
            {events.map(e => (
              <tr key={e.id}>
                <td>{e.id}</td>
                <td>{e.name}</td>
                <td>{e.displayName}</td>
                <td>{e.severity}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {translations && translations.length > 0 && (
        <table className="event-table">
          <thead>
            <tr>
              <th>TxtId</th>
              {allLcIds.map(lcidNumber => (
                <th key={lcidNumber}>
                  {lcid.from(lcidNumber) || '??'} ({lcidNumber})
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {translations.map(t => (
              <tr key={t.txtId}>
                <td>{t.txtId}</td>
                {allLcIds.map(lcidId => (
                  <td key={lcidId}>{t.languages[lcidId] || '-'}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </>
  );
};

export default EventTableBlock;
